/**
 * Provider component for service version selection state.
 * Separated to enable React Fast Refresh in components.
 */

import { useCallback, useMemo, useState } from "react";
import { DeployedVersionInfo } from "./service-version-selection-types";
import { ServiceVersionSelectionStateContext } from "./service-version-selection-context";

export const ServiceVersionSelectionStateProvider = ({
  children,
  initialDeployedVersionInfo,
}: {
  children?: React.ReactNode;
  initialDeployedVersionInfo?: DeployedVersionInfo | null;
}) => {
  const [typeByVersion, setTypeByVersion] = useState<Record<string, string>>(
    {},
  );
  const [deployedVersionInfo, setDeployedVersionInfo] =
    useState<DeployedVersionInfo | null>(initialDeployedVersionInfo ?? null);

  const setTypeForVersion = useCallback((version: string, type?: string) => {
    setTypeByVersion((prev) => {
      if (!type) {
        const { [version]: _removed, ...rest } = prev;
        return rest;
      }
      return {
        ...prev,
        [version]: type,
      };
    });
  }, []);

  const value = useMemo(
    () => ({
      typeByVersion,
      setTypeForVersion,
      deployedVersionInfo,
      setDeployedVersionInfo,
    }),
    [
      typeByVersion,
      setTypeForVersion,
      deployedVersionInfo,
      setDeployedVersionInfo,
    ],
  );

  return (
    <ServiceVersionSelectionStateContext.Provider value={value}>
      {children}
    </ServiceVersionSelectionStateContext.Provider>
  );
};
